/*
 * Module for the Benefit Payment Registers Detail view
 */
rs.module("content/participant/benefit/paymentregisters/detail",

    [ /* dependencies */ ],

    function () {

        // Initialize the page
        function initialize(jsSelectors, cssClasses) {

            // Unpack js selectors
            var paymentRegisterInfoContainer = $.js(jsSelectors.paymentRegisterInfoContainer);
            var referencedPaymentContainer = paymentRegisterInfoContainer.js(jsSelectors.referencedPaymentContainer, { required: false });

            if (referencedPaymentContainer) {
                var referencedPaymentHoverPopup = referencedPaymentContainer.js(jsSelectors.referencedPaymentHoverPopup, { required: false });

                if (referencedPaymentHoverPopup) {
                    // show/hide interest parameters on hover
                    referencedPaymentContainer.hoverIntent({
                        handlerOver: function (event) {
                            referencedPaymentHoverPopup.toggleClass(cssClasses.visible, true);
                        },
                        handlerOut: function (event) {
                            referencedPaymentHoverPopup.toggleClass(cssClasses.visible, false);
                        },
                        hoverOutDelay: 400
                    });
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);